export const platforms = {
  LINK: 'link',
  UC: 'uc',
  CPAAS: 'cpaas'
}

export const notificationTypes = {
  WEBSOCKET: 'websocket',
  PUSH: 'push'
}

export const connCheckResponsibility = {
  CLIENT: 'client',
  SERVER: 'server'
}

export const connCheckMethods = {
  KEEP_ALIVE: 'keepAlive',
  PING_PONG: 'pingPong'
}
